export function sharedCandidateTarget(search){
 const id=new URLSearchParams(search).get('adayPaylasim');
 return /^[a-f\d]{8}-[a-f\d]{4}-[a-f\d]{4}-[a-f\d]{4}-[a-f\d]{12}$/i.test(id||'')?'/profil?sekme=paylasilan-adaylar&paylasim='+encodeURIComponent(id):null;
}
